import React, { Suspense } from "react";
import PropTypes from "prop-types";

const LoaderProvider = ({ children }) => (
    <Suspense
        fallback={(
            <div className="loader-container">
                <div className="loader-ellipsis"></div>
            </div>
        )}
    >
        {children}
    </Suspense>
);

LoaderProvider.propTypes = {
    children: PropTypes.node.isRequired
};

export default LoaderProvider;
